import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import StaffSelectionTable, { StaffData } from '../StaffSelectionTable'
import { CreateMeetingLinkFormValues } from '../CreateMeetingLinkForm'

type WizardStaffStepProps = {
  staffs: StaffData[]
}

export default function WizardStaffStep(props: WizardStaffStepProps) {
  const { staffs } = props
  const { t } = useTranslation()
  const { values, setFieldValue } = useFormikContext<CreateMeetingLinkFormValues>()

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t('page.createMeetingLink.wizard.staff.description')}
      </Typography>
      <StaffSelectionTable
        data={staffs}
        onSelect={(selectedStaffsId: string[]) => setFieldValue('staffs', selectedStaffsId)}
        readOnly={false}
        selected={values.staffs}
      />
    </Box>
  )
}
